import React from 'react';
import { Popup } from '../../shared/GenericPopup';
import donationImage from '../../../assets/Img/Give-Gift--Streamline-Sharp.png';

interface DonationSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  email: string;
  paymentReferenceId: string;
  amount?: number;
}

const DonationSuccessModal: React.FC<DonationSuccessModalProps> = ({
  isOpen,
  onClose,
  email,
  paymentReferenceId,
  amount
}) => {
  if (!isOpen) return null;

  const handleReturnHome = () => {
    onClose();
    // You can add navigation logic here if needed
    window.location.href = 'https://stlukehealthcare.org/donate/';
  };

  return (
    <Popup onClose={onClose}>
      <div className="text-center p-6">
        {/* Donation Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center">
            <img 
              src={donationImage} 
              alt="Donation" 
              className="w-12 h-12 object-contain"
            />
          </div>
        </div>

        {/* Main Heading */}
        <h1 className="text-3xl font-bold text-[#153B4E] mb-4">
          Thank you!
        </h1>

        {/* Confirmation Message */}
        <p className="text-gray-600 mb-6 text-sm">
          Your generous donation of{' '}
          <span className="font-bold">
            {amount ? `$${amount.toFixed(2)}` : 'your amount'}
          </span>{' '}
          has been processed successfully. Please find the confirmation number below.
        </p>

        {/* Confirmation Number Box */}
        <div className="bg-gray-100 rounded-lg p-4 mb-6">
          <div className="text-gray-600 text-sm mb-2">Confirmation Number</div>
          <div className="text-l font-bold text-[#153B4E]">
            {paymentReferenceId}
          </div>
        </div>

        {/* Receipt Information */}
        <p className="text-gray-600 mb-8 text-sm">
          A receipt has been sent to{' '}
          <span className="font-bold">{email}</span>
        </p>

        {/* Return to Homepage Button */}
        <button
          onClick={handleReturnHome}
          className="w-full bg-[#153B4E] text-white font-semibold py-3 px-6 rounded-lg text-lg hover:bg-[#0f2a38] transition-colors duration-300"
        >
          Return to Homepage
        </button>
      </div>
    </Popup>
  );
};

export default DonationSuccessModal;
